import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungRegensburg() {
  return (
    <CityPageTemplate
      city="Regensburg"
      slug="regensburg"
      intro="Regensburg als UNESCO-Welterbe und Wirtschaftsstandort – lass Dein Geld genauso wertvoll werden."
      description="Unabhängige & digitale Finanzberatung für Regensburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
